import styled, { keyframes } from 'styled-components';
import * as colors from '../../../../config/colors';

const fadeIn = keyframes`
   from {
      opacity: 0;
      transform: translateX(-8px);
   }
   to {
      opacity: 1;
      transform: translateX(0);
   }
`;

/**
 * Styled-component standalone pros popovers renderizados via portal.
 *
 * Por que esse arquivo existe:
 *   Os popovers são renderizados via ReactDOM.createPortal no <body>,
 *   fora do <Nav> que escopa os estilos do styled.js. Por isso as classes
 *   `.group-popover` e `.module-popover` do styled.js NÃO aplicam aqui.
 *   Precisamos de estilos próprios que não dependam de ancestralidade.
 *
 * O visual é intencionalmente similar ao .group-popover/.module-popover
 * do styled.js pra manter consistência. Se um dia aqueles forem removidos
 * (quando ninguém mais renderizar popover inline), esta fica como fonte única.
 */
export const PortalPopover = styled.div`
   position: fixed;
   top: ${(p) => p.$top}px;
   left: ${(p) => p.$left}px;
   z-index: 9999;
   min-width: 192px;
   padding: 6px 0;
   background: #fff;
   border: 1px solid #e5e7eb;
   border-radius: 10px;
   box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
   animation: ${fadeIn} 180ms cubic-bezier(0.2, 0, 0, 1);

   .portal-popover-title {
      margin: 0 0 4px;
      padding: 0 14px;
      color: #9ca3af;
      font-size: 0.65rem;
      font-weight: 600;
      letter-spacing: 0.08em;
      text-transform: uppercase;
   }

   .portal-popover-item {
      /* Overrides contra GlobalStyles.js — o <button> global pinta de azul */
      background: transparent;
      color: #374151;
      font-weight: 500;
      padding: 8px 14px;
      border-radius: 0;

      display: flex;
      align-items: center;
      gap: 10px;
      width: 100%;
      font-size: 0.8rem;
      font-family: inherit;
      text-align: left;
      text-decoration: none;
      border: none;
      cursor: pointer;
      transition: background 140ms ease, color 140ms ease;

      &:hover {
         background: #f9fafb;
         color: ${colors.primaryDarkColor};

         .portal-popover-icon {
            background: ${colors.primaryDarkColor}10;
            color: ${colors.primaryDarkColor};
         }
      }

      &.active {
         color: ${colors.primaryDarkColor};
         font-weight: 600;

         .portal-popover-icon {
            background: ${colors.primaryDarkColor}20;
            color: ${colors.primaryDarkColor};
         }
      }
   }

   .portal-popover-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 26px;
      height: 26px;
      flex-shrink: 0;
      color: #6b7280;
      background: #f3f4f6;
      border-radius: 6px;
      transition: background 140ms ease, color 140ms ease;
   }

   .portal-popover-label {
      flex: 1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
   }

   .portal-popover-active-dot {
      width: 5px;
      height: 5px;
      flex-shrink: 0;
      border-radius: 50%;
      background: ${colors.primaryDarkColor};
      animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
   }

   .portal-popover-new-badge {
      display: inline-flex;
      align-items: center;
      flex-shrink: 0;
      padding: 2px 7px;
      border-radius: 999px;
      background: #10b981;
      color: #fff;
      font-size: 0.6rem;
      font-weight: 700;
      letter-spacing: 0.02em;
      line-height: 1;
   }

   @keyframes pulse {
      0%, 100% { opacity: 1; }
      50% { opacity: 0.4; }
   }
`;
